/** @format */

import React from 'react';
import {
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Typography,
  List,
  ListItem,
} from '@mui/material';
import { ConfirmDialog, Icons } from 'components';
import { useNavigate } from 'react-router-dom';
import useCustomHook from '../../hooks';
import createToast from 'components/Toast/Toast';
import { getDynamicObjectAction } from 'utility';
import { useStyles } from './style';

import { useCopy } from 'hooks';
import keysService from '../../services/KeysService';

const services = new keysService();

export default function Key({ item, expanded, setCurrentPage, currentPage, popKey = () => { }, onExpand, itemKey, ...props }) {
  // --STATES--//

  const { copyItem } = useCopy();
  const actionsList =
    getDynamicObjectAction([
      'removeKeyListBtn',
      'updateKeyListBtn']);
  // --HOOKS--//

  const classes = useStyles();
  const navigate = useNavigate();
  const {
    loading,
    setLoading,
    hidePass,
    setHidePass,
    imageIsLoaded,
    setImageIsLoaded,
    openDialog,
    setOpenDialog,
  } = useCustomHook();
  // --API--//
  const deleteKey = async () => {
    let result;
    setLoading(true);
    try {
      result = await services.deleteKey(item?.client_id);

      createToast('موفق', `کلید اتصال ${item?.name} با موفقیت حذف شد.`, 'success');
      popKey(item?.client_id);
      setLoading(false);
      setCurrentPage(1)
    } catch (error) {
      setLoading(false);
      return;
    }
    setOpenDialog(false);
  };

  // -- LOCAL VARIABLES --//

  // -- OTHER FUNCTIONS--//
  const changeRoute = (link, item) => {
    navigate(link, item);
  };
  const removeKey = (index) => {
    setOpenDialog(true);
  };

  return (
    <Accordion
      className={classes.root}
      expanded={expanded == itemKey}
    //   onChange={() => expanded == itemKey ? onExpand(-1) : null}
    >
      {/* Key Header Info */}
      <AccordionSummary
        className={classes.header}
        aria-controls="panel1bh-content"
        id={`panel${itemKey}bh-header`}
      >
        {/* Confirm Delete */}
        <ConfirmDialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          onConfirm={() => deleteKey()}
          title="توجه"
          loading={loading}
          confirmButtonText="بلی"
          cancelButtonProps="خیر"
        >
          <>
            با حذف کلید اتصال ({item?.name})، اطلاعات زیر نیز از بین می‌روند:
            <List className={classes.list}>
              <ListItem>
                <span>•</span> تمامی توکن های دسترسی
              </ListItem>
              <ListItem>
                <span>•</span> تمامی مجوزهای دسترسی اعطا شده از جانب کاربران
              </ListItem>
              <ListItem>
                <span>•</span> متادیتاهای ذخیره شده برای کاربران
              </ListItem>
            </List>
            <Typography>آیا اطمینان دارید؟</Typography>
          </>
        </ConfirmDialog>

        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <img
              alt="کلید"
              className={classes.logo}
              src={item?.icon ?? './images/key.jpg'}
              style={{ display: imageIsLoaded ? 'block' : 'none' }}
              onLoad={() => setImageIsLoaded(true)}
            />
            <img
              alt="کلید"
              className={classes.logo}
              src="./images/key.jpg"
              style={{ display: imageIsLoaded ? 'none' : 'block' }}
            />
          </Grid>
          <Grid item xs={12} md={3} className={classes.keyTitlePart}>
            <Typography variant="h5" className={classes.keyTitle}>
              {item?.name}
              {!item?.active ? (
                <Typography variant="subtitle2" className={classes.disableClient}>
                  {' '}
                  غیرفعال
                </Typography>
              ) : (
                ''
              )}
            </Typography>
            {item?.description ? (
              <Typography variant="h6" className={classes.keyDesc}>
                {item.description}
              </Typography>
            ) : null}
          </Grid>

          <Grid item xs={12} md={4} className={classes.clientPart}>
            <Typography variant="h5" className={classes.clientTitle}>
              شناسه مشتری
              <span>(Client ID)</span>
            </Typography>
            <Typography variant="h6" className={classes.clientDesc}>
              {item?.client_id}
              <span className={classes.copyIcon} onClick={() => copyItem(item?.client_id)}>
                <Icons icon="copy" color="#b5b5b5" hover="2b3990" size="20" />
              </span>
            </Typography>
          </Grid>

          <Grid item className={classes.actions}>


            <Button
              startIcon={expanded !== itemKey ? <Icons icon="CaretDown" color="#fffff" size="25" />
                : <Icons icon="CaretUp" color="#fffff" size="23" />}
              variant="contained"
              className={classes.expandBtn}
              onClick={() => onExpand(expanded === itemKey ? -1 : itemKey)}
            >
              {expanded === itemKey ? 'بستن جزئیات' : 'جزئیات کلید'}
            </Button>

            {actionsList['updateKeyListBtn'] && (
              <span
                className={classes.actionsIcon}
                style={{ marginRight: 10 }}
                onClick={() => changeRoute(`/Keys/EditApiKey/${item.client_id}`)}
              >
                <Icons icon="editPen" color="#2B3990" hover="2b3990" size="18" />

              </span>
            )}
            {actionsList['removeKeyListBtn'] && (
              <span className={classes.actionsIcon} onClick={removeKey}>
                <Icons icon="Trash" color="#2B3990" hover="2b3990" size="20" />

              </span>
            )}
          </Grid>
        </Grid>
      </AccordionSummary>

      {/* Key Expand Details */}
      <AccordionDetails className={classes.details}>
        <div className={classes.detailsContainer}>
          {/* First Line Details */}
          <Grid
            className={classes.detailRow}
            container
            justifyContent="space-between"
            alignItems="center"
          // wrap="nowrap"
          >
            <Grid item container alignItems="center" style={{ gap: '5px' }}
              xs={12} md={3}>

              {item?.allowedGrantTypes?.includes('implicit') ? (
                <Icons icon="Accept" color="#303d8f" size="25" />

              ) : (
                <Icons icon="Accept" color="#bfbfbf" size="25" />
              )}

              <Typography className={classes.property}>توکن یک مرحله‌ای</Typography>
            </Grid>
            <Grid item container alignItems="center" xs={12} md={3} style={{ gap: '5px' }}>

              {item?.captchaEnabled ? (
                <Icons icon="Accept" color="#303d8f" size="25" />

              ) : (
                <Icons icon="Accept" color="#bfbfbf" size="25" />
              )}

              <Typography className={classes.property}>نمایش عبارت تصادفی</Typography>
            </Grid>
            <Grid item container alignItems="center" xs={12} md={3} style={{ gap: '5px' }}>
              {item?.signupEnabled ? (
                <Icons icon="Accept" color="#303d8f" size="25" />

              ) : (
                <Icons icon="Accept" color="#bfbfbf" size="25" />
              )}

              <Typography className={classes.property}>اجازه ثبت نام کاربر</Typography>
            </Grid>
            <Grid item container alignItems="center" xs={12} md={3} style={{ gap: '5px' }}>
              {item?.active ? (
                <Icons icon="Accept" color="#303d8f" size="25" />

              ) : (
                <Icons icon="Accept" color="#bfbfbf" size="25" />
              )}

              <Typography className={classes.property}>ورود به صورت PKCE</Typography>
            </Grid>
          </Grid>
          <Grid
            className={classes.detailRow}
            container
            justifyContent="space-between"
            alignItems="center"
          // wrap="nowrap"
          >
            <Grid
              item
              container
              alignItems="center"
              xs={12}
              md={3}
              className={classes.supportNumber}
            >
              <Typography className={classes.property}>
                شماره تماس پشتیبانی:
                {'  '}
                {item?.supportNumber ?? '-'}
              </Typography>
            </Grid>
          </Grid>
          {/* Passwords Line Details */}
          <Grid
            className={classes.detailRow}
            container
            justifyContent="space-between"
            alignItems="center"
          // wrap="nowrap"
          >
            <Grid item container alignItems="center" xs={12} md={3}>
              <Typography className={classes.partTitle}>
                رمز مشتری
                <span>(Client Secret)</span>
              </Typography>
            </Grid>
            <Grid
              item
              container
              alignItems="center"
              xs={12}
              md={3}
              style={{ marginInlineEnd: 'auto' }}
            >
              <Button onClick={() => setHidePass(!hidePass)} className={classes.showPassBtn}>
                {hidePass ? 'نمایش رمز' : 'مخفی‌سازی رمز'}
              </Button>
              <Typography className={classes.passText}>
                {!hidePass ? item?.client_secret : '*********'}
              </Typography>

              <span className={classes.copyIcon} style={{ top: '0' }}
                onClick={() => copyItem(item?.client_secret)}>
                <Icons icon="copy" color="#b5b5b5" hover="2b3990" size="20" />
              </span>
            </Grid>
          </Grid>
          {/* Scope Part */}
          <Grid
            className={classes.detailRow}
            container
            justifyContent="space-between"
            alignItems="flex-start"
          // wrap="nowrap"
          >
            <Grid item container alignItems="center" xs={12} md={3}>
              <Typography className={classes.partTitle}>
                محدوده مجاز
                <span>(Scope)</span>
                {item?.allowedScopes?.length > 0 ? (
                  <span className={classes.copyIcon}
                    onClick={() => copyItem(item?.allowedScopes.join(' '))}>
                    <Icons icon="copy" color="#b5b5b5" hover="2b3990" size="20" />
                  </span>
                ) : null}
              </Typography>
            </Grid>
            <Grid item xs={12} md={9} style={{ direction: 'ltr' }} className={classes.partDetails}>
              {item?.allowedScopes
                ? item.allowedScopes.map((v, k) => (
                  <Typography key={`${item.id}_${v}_${k}`} className={classes.scopeItem}>
                    {v}
                  </Typography>
                ))
                : null}
            </Grid>
          </Grid>
          {/* Permissions Part */}
          <Grid
            className={classes.detailRow}
            container
            justifyContent="space-between"
            alignItems="flex-start"
            wrap="nowrap"
          >
            <Grid item container alignItems="center" xs={12} md={3}>
              <Typography className={classes.partTitle}>دسترسی‌ها</Typography>
            </Grid>
            <Grid item xs={12} md={9} style={{ direction: 'ltr' }} className={classes.partDetails}>
              {item?.allowedGrantTypes
                ? item.allowedGrantTypes.map((v, k) => (
                  <Typography key={`${item.id}_${v}_${k}`} className={classes.scopeItem}>
                    {v}
                  </Typography>
                ))
                : null}
            </Grid>
          </Grid>
          {/* Return Addresses Part */}
          <Grid
            className={classes.detailRow}
            container
            justifyContent="space-between"
            alignItems="flex-start"
          // wrap="nowrap"
          >
            <Grid item container alignItems="center" xs={12} md={3}>
              <Typography className={classes.partTitle}>آدرس‌های بازگشت</Typography>
            </Grid>
            <Grid item xs={12} md={9} style={{ direction: 'ltr' }} className={classes.partDetails}>
              {item?.allowedRedirectUris
                ? item.allowedRedirectUris.map((v, k) => (
                  <Typography key={`${item.id}_${v}_${k}`} className={classes.addressItem}>
                    {v}
                  </Typography>
                ))
                : null}
            </Grid>
          </Grid>
        </div>
      </AccordionDetails>
    </Accordion >
  );
}
